import HeaderPartnerDefault from './Header.PartnerDefault';

export default HeaderPartnerDefault;
